// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import posEntity from './entities/pos.json';
import posMenu from '../pages/pos/menu.json';
import posFullForm from '../pages/pos/forms/full.json';
import posContextForm from '../pages/pos/forms/context.json';
import posMiniForm from '../pages/pos/forms/mini.json';
import posLookupForm from '../pages/pos/forms/lookup.json';
import posTableView from '../pages/pos/views/table.json';
import posStagesView from '../pages/pos/views/stages.json';
import posCardsView from '../pages/pos/views/cards.json';
import posInlineView from '../pages/pos/views/inline.json';
import posBacklogView from '../pages/pos/views/backlog.json';
import posSplitView from '../pages/pos/views/split.json';
import posCalendarView from '../pages/pos/views/calendar.json';
import posDashboardView from '../pages/pos/views/dashboard.json';

/** Тип запису «Позиція» зі сторінками пакета: меню, форми та подання з pages/pos/. */
export const posDefinition: IRecordTypeDefinition = {
  ...posEntity,
  views: assembleViewSet({
      table: posTableView,
      stages: posStagesView,
      cards: posCardsView,
      inline: posInlineView,
      backlog: posBacklogView,
      split: posSplitView,
      calendar: posCalendarView,
      dashboard: posDashboardView,
  }),
  form: posFullForm,
  forms: { full: posFullForm, context: posContextForm, mini: posMiniForm, lookup: posLookupForm },
  menu: posMenu,
} as IRecordTypeDefinition;
